import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import { RouterApp } from "./Router/Router";
import { App } from "./App";
import TranslationComponent from "./componets/translationComponent";


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
   <App/>
    </BrowserRouter>
  </React.StrictMode>
);
